import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment-timezone";
import DateRangePicker from "../common/DateRangePicker";
import TextField from "../common/TextField";
import MenuItem from "../common/MenuItem";
import Button from "../common/Button";
import { checkPrivileges } from "../../Helpers";
import SearchDropdown from "../Users/SearchDropdown";
import AsyncSelect from "../common/asyncSelect";
import instance from "../../axios";

const TicketHeader = ({
  translate,
  isShowCreateForm,
  handleAddCloseForm,
  onSearch,
  initialStatus = "",
  initialSearch = "",
  logInUser,
  defaultUsersList
}) => {
  const [status, setStatus] = useState(initialStatus);
  const [searchText, setSearchText] = useState(initialSearch);
  const [dateRangeDisplay, setDateRangeDisplay] = useState(null);
  const [dateRangeApi, setDateRangeApi] = useState(null);
  const [cnValue, setCnValue] = useState("")
  const [resultMessageUser, setResultMessageUser] = useState("")
  const [assignTo, setAssignTo] = useState({
    id: logInUser?.id,
    name: logInUser?.name
  })


  const handleDates = (e, date) => {
    if (!date?.startDate || !date?.endDate) return;

    const end = date.endDate.clone().set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999,
    });

    const apiRange = {
      from: moment(date.startDate).toISOString(),
      to: end.toISOString(),
    };

    const displayRange =
      moment(date.startDate).format("YYYY-MM-DD HH:mm") +
      " - " +
      end.format("YYYY-MM-DD HH:mm");

    setDateRangeDisplay(displayRange);
    setDateRangeApi(apiRange);
  };


  const handleSearch = () => {
    if (onSearch) {
      onSearch({
        status,
        searchText,
        dateRange: dateRangeApi,
        contractNumber: cnValue?.contractNumber || "",
        assignTo: assignTo?.id || ""
      });
    }
  };


  const handleClear = () => {
    setStatus("");
    setSearchText("");
    setDateRangeDisplay(null);
    setDateRangeApi(null);
    setCnValue("")
    setAssignTo("")

    if (onSearch) {
      onSearch({
        status: "",
        searchText: "",
        dateRange: null,
        contractNumber: null,
        assignTo: "",
      });
    }
  };

  const handleChangecnValue = (val) => {
    setCnValue(val)
  }

  const searchUsersList = async (inputValue) => {
    if (!inputValue) return []
    try {
      const fetchApi = `/api/users/get?search=${inputValue}&all=true&userId=${logInUser.id}&userTypes=4`
      const response = await instance.get(fetchApi)
      const users = response?.data?.map((acc) => ({
        id: acc?.entity?.id,
        label: acc?.entity?.name,
      })) || []
      setResultMessageUser(users.length === 0 ? "No option found" : "")
      return users
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const handleChange = (field, value) => {
    setAssignTo(value)
  };
  const isDisabledClear =
    !status &&
    !assignTo &&
    !cnValue &&
    !searchText &&
    !dateRangeApi?.from &&
    !dateRangeApi?.to;

  return (
    <Box
      mb={3}
      p={2}
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap={1}
        flexWrap="wrap"
      >
        {/* LEFT SIDE - TITLE */}
        <Typography variant="h6" fontWeight="bold" noWrap>
          {isShowCreateForm
            ? translate("createEditTicket")
            : translate("ticketsList")}
        </Typography>

        {/* RIGHT SIDE - EVERYTHING ELSE */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
          flexWrap="wrap"
        >
          {!isShowCreateForm && (
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ flexWrap: "wrap" }}
            >
                    <Box sx={{ minWidth: 200 }}>
                <DateRangePicker
                  maintenanceTop
                  fill
                  selectedDate={dateRangeDisplay}
                  label={
                    translate("reportFrom") +
                    " - " +
                    translate("reportTo")
                  }
                  translate={translate}
                  onEvent={handleDates}
                />
              </Box>
              <Box sx={{ minWidth: 180,mt:0.5 }}>
                <SearchDropdown
                  apiUrl={(search) =>
                    `/api/accounts/getlimiteddata?search=${search}&all=true&userId=${logInUser?.id}`
                  }
                  value={cnValue}
                  onChange={handleChangecnValue}
                  label={translate("searchAccounts")}
                />
              </Box>

              <Box sx={{ minWidth: 180 }}>
                <AsyncSelect
                  selectName="assignTo"
                  isMulti={false}
                  isClearable
                  value={assignTo}
                  placeholder={translate("assignTo")}
                  resultMessage={resultMessageUser}
                  defaultOptions={defaultUsersList}
                  handleChange={handleChange}
                  loadOptions={searchUsersList}
                />
              </Box>

        

              <TextField
                select
                label={translate("status")}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{ minWidth: 150 }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="New">New</MenuItem>
                <MenuItem value="Assigned">Assigned</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Awaiting Customer Response">
                  Awaiting Customer Response
                </MenuItem>
                <MenuItem value="Resolved">Resolved</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </TextField>

              <TextField
                label={translate("sharedSearch")}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ minWidth: 150 }}
              />

              <Button
                variant="contained"
                onClick={handleSearch}
                disabled={isDisabledClear}
                sx={{ textTransform: "none", whiteSpace: "nowrap" }}
              >
                {translate("sharedSearch")}
              </Button>

              <Button
                onClick={handleClear}
                sx={{ textTransform: "none", whiteSpace: "nowrap" }}
              >
                {translate("clear")}
              </Button>
            </Box>
          )}

          {/* CREATE / BACK BUTTON */}
          {checkPrivileges("ticketCreate") && (
            <Button
              onClick={handleAddCloseForm}
              variant="contained"
              color={isShowCreateForm ? "secondary" : "success"}
              sx={{ textTransform: "none", whiteSpace: "nowrap" }}
            >
              {isShowCreateForm
                ? translate("back")
                : translate("create")}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TicketHeader;